export enum ADPRelationshipEnum {
    Spouse = 1,
    Parent = 2,
    LegalGuardian = 3,
    PublicTrustee = 4,
    PowerOfAttorney = 5
}
